"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ClusterYellow = function ClusterYellow(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Clustering_gelb"), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "11.92",
    r: "6.66",
    style: {
      fill: '#f5d933'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,20.52a8.6,8.6,0,0,1-6.5-3,.51.51,0,1,1,.76-.66,7.59,7.59,0,0,0,11.49,0,.51.51,0,1,1,.77.66A8.6,8.6,0,0,1,12,20.52Z",
    style: {
      fill: '#f5d933'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.64,15.1l-.17,0a.51.51,0,0,1-.31-.64,7.6,7.6,0,0,0-5.73-10,.51.51,0,0,1,.19-1,8.61,8.61,0,0,1,6.49,11.28A.51.51,0,0,1,19.64,15.1Z",
    style: {
      fill: '#f5d933'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.36,15.11a.51.51,0,0,1-.48-.34,8.61,8.61,0,0,1,6.54-11.3.51.51,0,1,1,.18,1,7.6,7.6,0,0,0-5.77,10,.51.51,0,0,1-.31.64A.5.5,0,0,1,4.36,15.11Z",
    style: {
      fill: '#f5d933'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,22.18a10.26,10.26,0,0,1-7.76-3.55A.51.51,0,0,1,5,18a9.25,9.25,0,0,0,14,0,.51.51,0,1,1,.77.66A10.26,10.26,0,0,1,12,22.18Z",
    style: {
      fill: '#f5d933',
      opacity: '0.8'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.21,15.65l-.17,0a.51.51,0,0,1-.31-.64,9.26,9.26,0,0,0-7-12.14.51.51,0,0,1,.19-1,10.27,10.27,0,0,1,7.75,13.46A.51.51,0,0,1,21.21,15.65Z",
    style: {
      fill: '#f5d933',
      opacity: '0.8'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.79,15.65a.51.51,0,0,1-.48-.34,10.27,10.27,0,0,1,7.8-13.48.51.51,0,1,1,.18,1A9.26,9.26,0,0,0,3.27,15a.51.51,0,0,1-.31.64A.5.5,0,0,1,2.79,15.65Z",
    style: {
      fill: '#f5d933',
      opacity: '0.8'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.34,16.15a.51.51,0,0,1-.48-.34A11.81,11.81,0,0,1,9.83.33a.51.51,0,1,1,.18,1,10.79,10.79,0,0,0-8.2,14.16.51.51,0,0,1-.31.64Z",
    style: {
      fill: '#f5d933',
      opacity: '0.7000000000000001'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,23.72a11.79,11.79,0,0,1-8.93-4.08A.51.51,0,1,1,3.84,19a10.78,10.78,0,0,0,16.33,0,.51.51,0,1,1,.77.66A11.79,11.79,0,0,1,12,23.72Z",
    style: {
      fill: '#f5d933',
      opacity: '0.7000000000000001'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.66,16.15l-.17,0a.51.51,0,0,1-.31-.64A10.8,10.8,0,0,0,14,1.33a.51.51,0,0,1,.19-1,11.81,11.81,0,0,1,8.91,15.48A.51.51,0,0,1,22.66,16.15Z",
    style: {
      fill: '#f5d933',
      opacity: '0.7000000000000001'
    }
  }));
};

var _default = ClusterYellow;
exports["default"] = _default;